import { useEffect } from 'react';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';

import { ApproversPermissions } from '../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import { DetailRequest, DetailRequestDefaultProp } from '../../../../utils/globalPropTypes';
import ApproverTabsForm from '../../../../components/ApproverForm/ApproverTabsForm';

import './ApproverForm.scss';

const ApproverContainer = ({ details, aprroverPermissions, setIsPendingAuthorization }) => {
  const initialValues = {
    approver: {
      approvers: []
    }
  };

  useEffect(() => {
    setIsPendingAuthorization(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Formik initialValues={initialValues}>
      {() => (
        <Form>
          <ApproverTabsForm
            approverField="approver"
            aprroverPermissions={aprroverPermissions}
            details={details}
          />
        </Form>
      )}
    </Formik>
  );
};

ApproverContainer.propTypes = {
  aprroverPermissions: ApproversPermissions,
  details: DetailRequest,
  setIsPendingAuthorization: PropTypes.func
};

ApproverContainer.defaultProps = {
  aprroverPermissions: {
    visualize: false,
    write: false
  },
  details: DetailRequestDefaultProp,
  setIsPendingAuthorization: () => false
};

export default ApproverContainer;
